import {
  instanceOfPayrollRunContractorVendorBreakdown,
  instanceOfPayrollRunEmployeeBreakdown,
  PayrollRun
} from "@wingspanhq/wingspan-api-sdk";

/**
 * How many items the run pays out, whichever payroll type it is: pay statements
 * for an `Employee` run, payables for a `ContractorVendor` one.
 *
 * `PayrollRun.breakdown` is a union of the two shapes with no discriminator
 * field, so it is narrowed by the SDK's `instanceOf*` guards rather than by the
 * run's `type` — the response itself decides. `0` when the read did not expand
 * the breakdown (see `useQueryPayrollRunBreakdown`).
 */
export const selectorPayrollRunBreakdownCount = (
  payrollRun: PayrollRun | undefined
): number => {
  const breakdown = payrollRun?.breakdown;

  if (!breakdown) {
    return 0;
  }

  if (instanceOfPayrollRunEmployeeBreakdown(breakdown)) {
    return breakdown.payStatementsCount;
  }

  if (instanceOfPayrollRunContractorVendorBreakdown(breakdown)) {
    return breakdown.payablesCount;
  }

  return 0;
};
